import React, { useState } from "react";
import PropTypes from "prop-types";
import { setPreview } from "./utils/previewFlag";

export const PageStateContext = React.createContext();
PageStateContext.displayName = "PageContext";

// Provides the current chapter ID to deeply nested components (e.g. RichText)
// without threading it through Topic → Article → ContentBuilder → RichText.
export const ChapterContext = React.createContext(null);
ChapterContext.displayName = "ChapterContext";

const PageContextProvider = ({ children, initialState }) => {
  const [pageState, setPageState] = useState(initialState);

  React.useEffect(() => {
    setPreview(!!pageState.isPreview);
  }, [pageState.isPreview]);

  const updatePageState = newState => {
    setPageState(prevState => ({ ...prevState, ...newState }));
  };

  return (
    <PageStateContext.Provider value={{ pageState, updatePageState }}>
      {children}
    </PageStateContext.Provider>
  );
};

PageContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initialState: PropTypes.object.isRequired,
};

export default PageContextProvider;